import React from "react";
import clsx from "clsx";
import { NetworkRepEntry } from "../../../../../network/@types/Url";
import styles from "./network-references.module.scss";
import { Icon, TooltipIcon } from "../../../../../../components";
import RenderWhen from "../../../../../../components/RenderWhen";
import NoData from "../../../../../../components/NoData";

type Props = {
  networkRepEntry: NetworkRepEntry;
};

export const NetworkReferenceReputationGridTitle = () => (
  <div className="flex flex-center">
    <span style={{ marginRight: "0.4em" }}>Reputation</span>
    <TooltipIcon
      icon="info-circle"
      message="Displaying 3rd party reputation info, and a malware icon for sources of malicious samples"
      className={styles.info_icon}
    />
  </div>
);

const NetworkReferenceReputation = ({ networkRepEntry }: Props) => (
  <div
    className={clsx(
      styles.reputation_col,
      styles[networkRepEntry.classification]
    )}
  >
    <RenderWhen
      condition={networkRepEntry.third_party_reputations?.total > 0}
      fallback={<NoData />}
    >
      {networkRepEntry.third_party_reputations?.malicious ?? 0}/
      {networkRepEntry.third_party_reputations?.total ?? 0}
    </RenderWhen>
    {networkRepEntry.associated_malware && <Icon name="malware" />}
  </div>
);

export default NetworkReferenceReputation;
